import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import usePrams -> to get showid from url in details page
import { fetchShows } from "../../redux/reducers/FetchReducer";
import { fetchShow } from "../../redux/actions/FetchActions";
import ShowCard from "./ShowCard";

function TVShowList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const shows = useSelector((state) => state.allData.shows); // state.allData.bothShows for all bothShows
    
    useEffect(() => {
        fetchShow().then((res)=>{
            dispatch(fetchShows(res.data.results));
        });        
    }, []);
    
    return (
        <div className="flex pb-5 px-5 overflow-x-auto">
            { shows?.map((show) => {
                return <ShowCard key={show.id} movie={show} />
            })}
        </div>
        
    );
}

export default TVShowList;
